import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=0168df91"
import script from "./Clipboard.vue?vue&type=script&lang=js"
export * from "./Clipboard.vue?vue&type=script&lang=js"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=0168df91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports